import * as React from 'preact/compat'
import Modal from './Modal'
import Api from '../api'
import { captureFetchException, loadStylesheet, showModal } from '../common/helpers'
import Loading from './Loading'
import SVG from './SVG'
import styles from '../../css/sg-alert.pcss.json'
import gameWatchCss from '../../css/game-watch-modal.pcss.json'
import CompilationCreator from './CompilationCreator'
import { showToast } from './toast'

interface PropTypes {
  onClose: () => void,
  gameId: number
}

interface StateTypes {
  loaded: boolean,
  compilations: Array<{
    id: number,
    title: string,
    public: 1 | 0,
    checked: boolean,
  }>
}

// noinspection JSUnusedGlobalSymbols
export default class GameAddToCompilation extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    loaded: false,
    compilations: []
  }

  modal = React.createRef<Modal>()

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('game-watch-modal')
  }

  componentDidMount() {
    this.load()
  }

  load = () => {
    this.setState({
      loaded: false
    }, () => {
      Api.get<Array<{
        id: number,
        title: string,
        public: 1 | 0,
        checked: boolean
      }>>({ url: `compilations/my?gameId=${this.props.gameId}` })
        .then((result) => {
          this.setState({
            loaded: true,
            compilations: result
          })
        })
        .catch(async (e) => {
          captureFetchException(e)
          showToast({
            type: 'error',
            text: 'Не удалось загрузить подборки пользователя'
          })
          await this.modal.current.close()
        })
    })
  }

  toggle = (compilation: {
    id: number,
    title: string,
    checked: boolean
  }) => {
    if (!compilation.checked) {
      this.addTo(compilation)
    } else {
      this.removeFrom(compilation)
    }
  }

  addTo = (compilation: {
    id: number,
    title: string,
    checked: boolean
  }) => {
    const compilations = [...this.state.compilations]
    const index = compilations.findIndex(compilation2 => compilation2.id === compilation.id)
    compilations[index].checked = true
    this.setState({
      compilations
    }, () => {
      Api.post({
        url: 'compilations/add-game',
        body: {
          compilationId: compilation.id,
          gameId: this.props.gameId
        }
      })
        .catch(() => {
          showToast({
            type: 'error',
            text: 'Не удалось добавить игру в подборку'
          })
          const compilations = [...this.state.compilations]
          compilations[index].checked = false
          this.setState({
            compilations
          })
        })
    })
  }

  removeFrom = (compilation: {
    id: number,
    title: string,
    checked: boolean
  }) => {
    const compilations = [...this.state.compilations]
    const index = compilations.findIndex(compilation2 => compilation2.id === compilation.id)
    compilations[index].checked = false
    this.setState({
      compilations
    }, () => {
      Api.post({
        url: 'compilations/remove-game',
        body: {
          compilationId: compilation.id,
          gameId: this.props.gameId
        }
      })
        .catch(() => {
          showToast({
            type: 'error',
            text: 'Не удалось удалить игру из подборки'
          })
          const compilations = [...this.state.compilations]
          compilations[index].checked = true
          this.setState({
            compilations
          })
        })
    })
  }

  showCompilationModal = () => {
    showModal(CompilationCreator, {
      id: 'new',
      afterSave: this.load
    })
  }

  render() {
    const { loaded, compilations } = this.state

    return <Modal ref={this.modal} showClose onClose={this.props.onClose}>
      {!loaded && <Loading/>}
      {loaded && <>
        <div className={gameWatchCss['title']} style='width: 100%; margin-bottom: 24px; max-width: none'>
          Добавить в подборку
        </div>
        <div className={styles['optionlist']}>
          {compilations.map(compilation => {
            return <div className={styles['optionlist__option']}>
              <styled-checkbox
                name='compilation'
                label={compilation.title}
                checked={compilation.checked}
                onChange={() => this.toggle(compilation)}
              />
              {compilation.public === 0
                && <SVG i='sg-new/eye-slash' className={styles['eye-slash']} title='Приватная подборка' adaptive/>
              }
            </div>
          })}
          <button type='button' className={styles['optionlist__option']} onClick={this.showCompilationModal}>
            <SVG i='sg-new/plus' adaptive/>
            Создать подборку
          </button>
        </div>
      </>}
    </Modal>
  }
}
